import { ActionTree } from 'vuex'
import { ISkillsState } from './types'
import { getSkills } from '@/api/skills/skills'
import Skill from '@/models-ts/Skill'
import { RootState } from '@/store'

export default {
  async getSkills({ commit, state }): Promise<Array<Skill>> {
    if (state.skills.isLoaded) {
      return [...state.skills.value, ...state.deprecatedSkills]
    }
    if (state.skills.isLoading && state.skills.promise) {
      return state.skills.promise.promise
    }
    commit('setSkillsLoading')
    const skillsData = await getSkills()
    const skills: Skill[] = skillsData.map(Skill.fromServer)
    const actualSkill: Skill[] = []
    const deprecatedSkills: Skill[] = []
    skills.forEach((skill) => {
      if (skill.is_removed || skill.change_id) {
        deprecatedSkills.push(skill)
      } else {
        actualSkill.push(skill)
      }
    })
    commit('setSkillsLoaded', actualSkill)
    commit('setDeprecatedSkills', deprecatedSkills)
    return skills
  },
} as ActionTree<ISkillsState, RootState>
